import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IMetaVisibleAsset } from './types';

export const META_VISIBLE_ASSETS_QUERY_KEY = 'admin/ads/meta/visible-assets';

export function useMetaVisibleAssetsQuery({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () => userSession.webServiceHelper.callAsync<IMetaVisibleAsset[]>('admin/ads/meta/visible-assets', 'GET'),
		queryKey: [META_VISIBLE_ASSETS_QUERY_KEY],
		enabled,
		refetchOnWindowFocus: false,
		meta: {
			toastErrorMessage: "Couldn't load Meta-visible ad accounts.",
			errorLogging: { fn: 'useMetaVisibleAssetsQuery' },
		},
	});
}
